export default "__VITE_ASSET__DYqfKT3j__"